import Private from "pages/private/Private";
import PublicOnly from "pages/private/PublicOnly";
import React, { useEffect, useState } from "react";
import * as fatchSet from "../api/api";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import ScrollToTop from "component/basic/scrollTopSet";
import { BottomErrMsg, LoadingBox, Popup } from "component/basic/popup";
import useGet from "api/useGet";
import { ErrorBoundary } from "react-error-boundary";
import { routes } from "./routes";
import { PageSizing } from "component/app/items";
import { IdFindPopup, JoinPopup, LoginPopup, NaviPopup, NomMemberPopup, PwFindPopup, TermsPopup, WelComePopup } from "pages/popup/Popup";
import { tokenSave } from "js/function";

const Router = () => {
    const [token,setToken] = useState(localStorage.getItem("token") ? true : false);
    
    const [popupData,setPopupData] =  useState(null);
    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(false);
    const [bottomMsgData,setBottomMsgData] =  useState({chk : 0});
    
    const [termsPopupData,setTermsPopupData] =  useState(null);
    const [welComePopupData,setWelComePopupData] =  useState(null);
    const [loginPopupData,setLoginPopupData] =  useState(null);
    const [joinPopupData,setJoinPopupData] =  useState(null);

    const [idFindPopupData,setIdFindPopupData] =  useState(null);
    const [pwFindPopupData,setPwFindPopupData] =  useState(null);

    const [nonMemberPopupData,setNonMemberPopupData] =  useState(null);

    const [naviPopup,setNaviPopup] =  useState(null);
    
    window.logIn = function(){
        setToken(true);
    }
    window.logOut = function(){
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");

        sessionStorage.clear();

        setToken(false);

        window.location.href = "/";
    }

    window.errPopupOpen = (data) => {
        if(data.data || data.alert){
            setPopupData({
                addClass:null,
                title:data.alert||"",
                text:data.data||"",
                closeType:data.closeType === false ? false : true,
                closeFunc:(e) => {},
                btnFunc0:(e)=>{if(data.func){data.func()}},
                btn0:"확인",
                btn0Type:"",
                btn1:"",
                btn1Type:"",
                btnFunc1:()=>{}
            });
        }
    }

    window.errMsg = (msg) => {
        if(msg){
            setBottomMsgData({
                text : msg,
                chk : bottomMsgData.chk + 1
            });
        }
    }

    window.loadingBox = (type) => {
        setLoadingBoxOpen(type);
    }

    window.sns_login = async (type, snsToken) => {
        const formData = new FormData();
        formData.append("is_token", 1);
        if(type == "google"){
            formData.append("token", snsToken);
        }
        if(type == "apple"){
            formData.append("code", snsToken);
        }
        if(type == "naver"){
            formData.append("token", snsToken);
        }
        if(type == "kakao"){
            formData.append("token", snsToken);
        }

        let headersData = token ? { 
            headers: {
                'Authorization': 'Bearer ' + `${localStorage.getItem("token")}`,
                'Accept' : 'application/json'
            },
            method: "POST",
            body: formData
        }
        :
        { 
            method: "POST",
            body: formData
        };

        fetch(`${process.env.REACT_APP_API_URL}/${type}/login${token ? "/connect" : ""}`, headersData).then(function (response) {
                return response.json();
        }).then((data) => {
            if(data.success === true){
                if(token){
                    sessionStorage.setItem("snsType",type);
                    window.location.href = "/mypage/profile";
                }else{
                    if(data.data.type == "login"){
                        localStorage.setItem("token",data?.data?.token?.access_token);
                        localStorage.setItem("refresh_token",data?.data?.token.refresh_token);

                        tokenSave(data?.data?.token?.access_token);

                        window.logIn();

                        setTimeout(() => {
                            if(sessionStorage.getItem("setUrl")){
                                let reUrl = sessionStorage.getItem("setUrl");
                                sessionStorage.removeItem("setUrl");
                                window.location.href = reUrl;
                            }else{
                                window.location.href = "/";
                            }
                        }, 100);
                    }else{
                        sessionStorage.setItem("token",data?.data?.token?.access_token);
                        sessionStorage.setItem("refresh_token",data?.data?.token?.refresh_token);

                        sessionStorage.setItem("joinSnsOpen",1);

                        window.location.href = "/";
                    }
                }
            } else {
                if(data.data || data.alert){
                    window.errPopupOpen(data);
                    if(token){
                        window.location.href = "/mypage/profile";
                    }else{
                        window.location.href = "/";
                    }
                }
            }
        }).catch((e) => {
            window.location.href = "/";
        });
    };

    window.termsPopupOpen = function(id,title,btnType,btnText,btnFunc){
        setTermsPopupData({
			addClass:"",
			title:title,
            subTitle:null,
			closeType:true,
			closeFunc:(e) => {setTermsPopupData(null)},
            closePcOn:true,
            btnText:btnText,
            btnFunc:btnFunc,
            terms:{
                id:id,
                title:title,
                btnType:btnType
            }
		});
    }

    window.termsPopupClose = function(){
        setTermsPopupData(null);
    }

    window.welComeOpen = function(type){
        setWelComePopupData({
			addClass:"subTitle_line_2",
			title:"로그인",
            subTitle:"A 렌터카 허브 첫 회원가입 시<br/>예약 시 사용 가능한 <b>10% 할인 쿠폰</b> 지급!",
			closeType:true,
			closeFunc:(e) => {setWelComePopupData(null)},
            closePcOn:true,
            nonMember:type === "nonMember" ? true : null
		});

        let nowUrl = new URL(window.location.href);
        sessionStorage.setItem("setUrl",nowUrl.pathname);
    }

    window.welComeClose = function(){
        setWelComePopupData(null);
    }


    window.nonLoginOpen = function(type, filterData, closeFuc){
        setWelComePopupData({
			addClass:"subTitle_line_2",
			title:"로그인",
            subTitle:"A 렌터카 허브 첫 회원가입 시<br/>예약 시 사용 가능한 <b>10% 할인 쿠폰</b> 지급!",
			closeType:true,
			closeFunc:(e) => {
                closeFuc()
            },
            closePcOn:true,
            nonMember:type === "nonMember" ? true : null,
            filterData: filterData ? true : false
		});

        let nowUrl = new URL(window.location.href);
        sessionStorage.setItem("setUrl",nowUrl.pathname);
    }

    window.nonMemberPopupOpen = function(){
        setNonMemberPopupData({
			addClass:"subTitle_line_1",
			title:"비회원 예약 확인",
            subTitle:"예약 번호와 예약자 정보를 입력해주세요.",
			closeType:true,
			closeFunc:(e) => {setNonMemberPopupData(null)}
		});
    }

    window.nonMemberPopupTextCh = function(data){
        let oldData = {...nonMemberPopupData};
        oldData.title = data.title;
        oldData.subTitle = data.subTitle;
        if(data.addClass){
            oldData.addClass = data.addClass;
        }

        setNonMemberPopupData(oldData);
    }

    window.nonMemberPopupClose = function(){
        setNonMemberPopupData(null);
    }

    window.loginPopupOpen = function(){
        setLoginPopupData({
			addClass:"subTitle_line_1",
			title:"일반 계정 로그인",
            subTitle:"서비스 로그인을 위해 계정정보를 입력해주세요.",
			closeType:true,
			closeFunc:(e) => {setLoginPopupData(null)}
		});
    }

    window.loginPopupClose = function(){
        setLoginPopupData(null);
    }

    window.joinPopupOpen = function(type){
        setJoinPopupData({
			addClass:"subTitle_line_1",
			title:type === "sns" ? "본인인증 정보 입력" : "가입할 계정정보 입력",
            subTitle:type === "sns" ? "회원가입을 위해 본인인증이 필요해요" : "회원가입을 위해 아래 계정정보를 입력해주세요.",
			closeType:true,
            joinType:type,
			closeFunc:(e) => {setJoinPopupData(null)}
		});
    }

    window.joinPopupTextCh = function(data){
        let oldData = {...joinPopupData};
        oldData.title = data.title;
        oldData.subTitle = data.subTitle;

        setJoinPopupData(oldData);
    }

    window.joinPopupClose = function(){
        setJoinPopupData(null);
    }

    window.idFindPopupOpen = function(){
        setIdFindPopupData({
			addClass:"subTitle_line_1",
			title:"본인인증 정보 입력",
            subTitle:"아이디 찾기를 위해선 본인인증이 필요해요",
			closeType:true,
			closeFunc:(e) => {setIdFindPopupData(null)}
		});
    }

    window.idFindPopupTextCh = function(data){
        let oldData = {...idFindPopupData};
        oldData.title = data.title;
        oldData.subTitle = data.subTitle;
        if(data.addClass){
            oldData.addClass = data.addClass;
        }

        setIdFindPopupData(oldData);
    }

    window.idFindPopupClose = function(){
        setIdFindPopupData(null);
    }
    
    window.pwFindPopupOpen = function(){
        setPwFindPopupData({
			addClass:"subTitle_line_1",
			title:"계정정보 입력",
            subTitle:"회원가입 시 입력한 아이디 정보를 입력해주세요.",
			closeType:true,
			closeFunc:(e) => {setPwFindPopupData(null)}
		});
    }

    window.pwFindPopupTextCh = function(data){
        let oldData = {...pwFindPopupData};
        oldData.title = data.title;
        oldData.subTitle = data.subTitle;
        if(data.addClass){
            oldData.addClass = data.addClass;
        }

        setPwFindPopupData(oldData);
    }

    window.pwFindPopupClose = function(){
        setPwFindPopupData(null);
    }

    window.naviPopupOpen = function(data){
        setNaviPopup({
            addClass:"",
            title:"내비게이션 선택",
            subTitle:null,
            closeType:true,
            closeFunc:(e) => {setNaviPopup(null)},
            closePcOn:true,
            kakaoUrl:data?.kakaoUrl||null
        });
    }

    window.naviPopupClose = function(){
        setNaviPopup(null);
    }

    const handleStorageChange = (e) => {
        if(token && !localStorage.getItem("token")){
            sessionStorage.clear();
            setToken(false);
            window.location.reload(true);
        }else if(!token && localStorage.getItem("token")){
            setToken(true);
            window.location.reload(true);
        }
    };

    useEffect(() => {
        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    //백화 시 노출
    const ErrorFallback = (err) => {
        console.log(err)
        return (
            <div className="popup active" style={{display:"block"}}>
                <div className="popup_cover"/>
                <div className="popupSetion">
                    <div className="popupTextBox">
                        <h2 className="popupTitle">서비스 이용에 불편을 드려 죄송합니다.</h2>
                        <p className="popupText">페이지가 없거나, 서비스 오류가 발생했습니다.<br/>잠시 후 다시 시도해주세요</p>
                    </div>
                    <div className="popup_btnBox">
                        <button type="button" className="btn_popup btn_popupLeft" onClick={() => {window.location.href = "/"}}>처음으로</button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <BrowserRouter>
                <ScrollToTop/>
                <PageSizing>
                <Routes>
                    {routes.map(
                        ({ exact, path, component, type }) => (
                            <Route
                                key={`public-route-${path}`}
                                exact={exact}
                                path={path}
                                element={type == "login" ? 
                                    token ? component : <Private/>
                                : type == "notLogin" ?  
                                    token ? <PublicOnly/> : component
                                : component}
                            />
                        )
                    )}

                    {/*404*/}
                    <Route
                        key={`public-route-/*`}
                        exact={true}
                        path="/*"
                        element={<PublicOnly/>}
                    />
                </Routes>
                </PageSizing>            
           
                <WelComePopup
                    popupData={welComePopupData}
                    closePcOn={true}
                />

                <LoginPopup
                    popupData={loginPopupData}
                />

                <JoinPopup
                    popupData={joinPopupData}
                />

                <IdFindPopup
                    popupData={idFindPopupData}
                />

                <PwFindPopup
                    popupData={pwFindPopupData}
                />

                <NomMemberPopup
                    popupData={nonMemberPopupData}
                />

                <TermsPopup
                    popupData={termsPopupData}
                    closePcOn={true}
                />

                <NaviPopup
                    popupData={naviPopup}
                />

                <Popup
                    data={popupData}
                />
                <BottomErrMsg
                    text={bottomMsgData.text ? bottomMsgData.text : ""}
                    chk={bottomMsgData.chk}
                />
                <LoadingBox openType={loadingBoxOpen}/>
            </BrowserRouter>
        </ErrorBoundary>
    );
};

export default Router;